import BaseModel from './base';

class PaymentModel extends BaseModel {
	getPayments(page = 1, pageSize = 50) {
		return this.get(`?page=${page}&pageSize=${pageSize}`);
	}
}

export default new PaymentModel('/payment');
